import { UFUOptions } from './index.types';

export const defaultOptions: Required<UFUOptions> = {
  clearFutureOnDo: false,
};
